import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Smartphone } from "lucide-react";
import { api, errMsg } from "../../lib/api";
import { useAuth, useLang } from "../../lib/ctx";

export const PhoneLogin = () => {
  const { lang } = useLang();
  const { setUser } = useAuth();
  const nav = useNavigate();
  const bm = lang === "bm";
  const [on, setOn] = useState(false);
  const [open, setOpen] = useState(false);
  const [step, setStep] = useState(1);
  const [f, setF] = useState({ phone: "", code: "", name: "" });
  const [isNew, setIsNew] = useState(false);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    api.get("/auth/phone/status").then((r) => { setOn(!!r.data.enabled); }).catch(() => {});
  }, []);
  if (!on) return null;
  const run = async (fn) => { setBusy(true); try { await fn(); } catch (x) { toast.error(errMsg(x)); } setBusy(false); };
  const send = (e) => { e.preventDefault(); run(async () => { const { data } = await api.post("/auth/phone/send", { phone: f.phone }); setF({ ...f, phone: data.phone }); setIsNew(data.new_user); setStep(2); toast.success(bm ? "Kod telah dihantar" : "Code sent"); }); };
  const verify = (e) => { e.preventDefault(); run(async () => { const { data } = await api.post("/auth/phone/verify", f); setUser(data); nav(["admin", "staff"].includes(data.role) ? "/admin" : "/account"); }); };
  if (!open) return (
    <button type="button" onClick={() => setOpen(true)} className="mt-3 flex w-full items-center justify-center gap-3 rounded-sm border border-[#dadce0] bg-white px-4 py-3 text-sm font-semibold text-[#3c4043] transition-colors duration-200 hover:bg-[#f8f9fa]" data-testid="phone-login-btn">
      <Smartphone className="h-5 w-5 text-[#ee4d2d]" />{bm ? "Log masuk dengan nombor telefon" : "Continue with phone number"}
    </button>
  );
  return (
    <form onSubmit={step === 1 ? send : verify} className="mt-3 space-y-2 rounded-sm border border-[#eee] bg-white p-4" data-testid="phone-login-form">
      <p className="text-sm font-semibold text-[#222]">{bm ? "Log masuk dengan telefon" : "Log in with phone"}</p>
      {step === 1 ? (
        <input required type="tel" value={f.phone} onChange={(e) => setF({ ...f, phone: e.target.value })} placeholder="012-345 6789" className="field" data-testid="phone-input" />
      ) : (
        <>
          <p className="text-xs text-zinc-500" data-testid="phone-sent-to">{bm ? `Kod dihantar ke ${f.phone}` : `Code sent to ${f.phone}`}</p>
          <input required inputMode="numeric" autoComplete="one-time-code" maxLength={10} value={f.code} onChange={(e) => setF({ ...f, code: e.target.value })} placeholder={bm ? "Kod 6 digit" : "6-digit code"} className="field tracking-[0.4em]" data-testid="otp-input" />
          {isNew && <input value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} placeholder={bm ? "Nama anda" : "Your name"} className="field" data-testid="phone-name-input" />}
        </>
      )}
      <button disabled={busy} className="btn-gold w-full" data-testid={step === 1 ? "phone-send-btn" : "otp-verify-btn"}>{busy ? "…" : step === 1 ? (bm ? "Hantar kod" : "Send code") : (bm ? "Sahkan & log masuk" : "Verify & log in")}</button>
      <div className="flex justify-between text-xs">
        {step === 2 && <button type="button" onClick={() => { setStep(1); setF({ ...f, code: "" }); }} className="text-[#ee4d2d]" data-testid="phone-change-btn">{bm ? "Tukar nombor / hantar semula" : "Change number / resend"}</button>}
        <button type="button" onClick={() => { setOpen(false); setStep(1); }} className="ml-auto text-zinc-500" data-testid="phone-cancel-btn">{bm ? "Batal" : "Cancel"}</button>
      </div>
    </form>
  );
};
